import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useRetryRequest } from "../../hooks/useRetryRequest";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getAppraisalData,
  getMileageIsReadyToRender
} from "../../store/selectors";

export const useRecalcSavedDeal = (recalculateSavedDealAppraisal: boolean) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vehicleAndQuestionsRequest, savedQuestionsAndAnswersRequest } =
    useRetryRequest();
  const { appraisalSessionId } = useSelector(getAppraisalData);
  const readyToRedirect =
    useSelector(getMileageIsReadyToRender) && appraisalSessionId;

  const location = window.location;
  const queryString = location.search;
  const { search } = window.location;
  const {
    appraisalSessionId: idParam,
    mileageForReappraisal: mileage,
    registration
  } = Object.fromEntries(new URLSearchParams(search));

  const redirectToMileage = () => {
    if(!recalculateSavedDealAppraisal) return
    dispatch(appraisalSlice.actions.setMileage(mileage));
    dispatch(appraisalSlice.actions.setIsReuseAppraisal(true));
    dispatch(appraisalSlice.actions.setIsSavedDealReappraisal(true));
    navigate(
      `/mileage/${queryString}&registration=${registration}&revisitAppraisals=${true}`
    );
  };

  // Set the appraisal session ID in store to enable fetch calls
  useEffect(() => {
    if (recalculateSavedDealAppraisal) {
      dispatch(appraisalSlice.actions.setAppraisalSessionId(idParam));
    }
  }, [idParam, recalculateSavedDealAppraisal]);

  // Fetch vehicle, questions and previous QandA set
  useEffect(() => {
    if (registration && appraisalSessionId && recalculateSavedDealAppraisal) {
      vehicleAndQuestionsRequest(registration);
      savedQuestionsAndAnswersRequest();
    }
  }, [registration, appraisalSessionId, recalculateSavedDealAppraisal]);

  // Redirect to milage page
  useEffect(redirectToMileage, [dispatch, location, readyToRedirect]);
};
